import React from "react";

const TextQuestion = ({ question, answer, onAnswer }) => {
  return (
    <div>
      <h2 className="font-bold text-lg text-gray-800 mb-4">{question.text}</h2>
      <textarea
        rows={6}
        value={answer || ""}
        onChange={(e) => onAnswer(e.target.value)}
        className="w-full border p-3 rounded-lg text-sm"
        placeholder="پاسخ خود را اینجا وارد کنید..."
      ></textarea>
    </div>
  );
};

export default TextQuestion;
